<template>
	<div
		class="panel solutions"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<div v-if="block.block_title" class="row align-items-end">
					<div class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="solutions_overview">
						<div v-if="block.description_top" class="title">
							{{ block.description_top }}
						</div>
						<p v-if="block.description_top" class="description">
							{{ block.description_bottom }}
						</p>
					</div>
				</div>
				<template v-if="block.items.length !== 0">
					<div
						v-for="(item, index) in block.items"
						:key="index"
						class="col-12 col-md-4 col-lg-2"
					>
						<div
							:id="item.number > 999 ? 'solution_students' : 'solution_companies'"
							class="solutions_item"
						>
							<div v-if="item.logo.length !== 0" class="digit">
								<b-img-lazy :src="item.logo.src" :alt="item.logo.alt" />
							</div>
							<div v-else-if="item.number" class="digit">
								{{ item.number }}
							</div>
							<div v-if="item.text" class="title">
								{{ item.text }}
							</div>
						</div>
					</div>
				</template>
			</div>

			<div class="panel_footer">
				<div class="row">
					<div class="col-12">
						<div class="btn-panel">
							<a
								v-if="block.button_left.text && block.button_left.link"
								:href="block.button_left.link"
								class="btn btn-primary"
							>{{ block.button_left.text }}</a>

							<a
								v-if="block.button_middle.is_chat"
								id="solutions_jivosite_top"
								onclick="return jivo_api.open(),!1"
								href="javascript:void(0)"
								class="btn btn-secondary-outer"
								role="button"
							>{{ $t('ChatWithAdvisor') }}</a>
							<a
								v-else-if="block.button_middle.text && block.button_middle.link"
								:href="block.button_middle.link"
								class="btn btn-secondary-outer"
							>{{ block.button_middle.text }}</a>

							<!--<a
								v-if="block.button_right.is_call_back"
								href="javascript:void(0)"
								onclick="ComagicWidget.openSitePhonePanel(); return false;"
								class="btn btn-secondary-outer"
							>{{ $t('CallBack') }}</a>-->
							<a
								v-else-if="block.button_right.text && block.button_right.link"
								:href="block.button_right.link"
								class="btn btn-secondary-outer"
							>{{ block.button_right.text }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelSolutions',
	mixins: [panel],
	props: ['block'],
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/home/panel-solutions';
</style>
